<style>
</style>
<template>
  <admin-layout>
    <template v-slot:breadcrumb>
      <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
        <li class="breadcrumb-item text-sm">
          <a class="opacity-5 text-white" href="javascript:;">Admin</a>
        </li>
        <li class="breadcrumb-item text-sm text-white" aria-current="page">
          Perfil
        </li>
      </ol>
    </template>

    <template v-slot:header>
      <h5 class="font-weight-bolder text-white mt-4 mb-0">Notificação</h5>
    </template>

    <template #content>
      <div class="row">
        <div class="col-12">
          <div class="card mb-4">
            <div class="card-header pb-0">
              <div class="row">
                <div class="col-8" v-if="$page.props.auth.hasRole.superAdmin">
                  <a href="/admin/notificacao_criar">
                  <button class="btn btn-primary">
                    Gestão de Notificação 
                  </button>
                </a>
                </div>
                <div class="col-4">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Pesquisar"
                    /><span class="input-group-text text-body"
                      ><i
                        class="fas fa-search"
                        aria-hidden="true"
                        style="cursor: pointer"
                      ></i
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th
                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Status
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Titulo
                      </th>

                      
                      <th
                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Data de criação
                      </th>
                      <th class="text-secondary opacity-7"></th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="data in notificacoes" :key="data.id">
                    
                      <td class="align-middle text-center">
                        <a href="">
                        <span
                          class="badge badge-sm"
                          :class="
                            data.status == 'lido'
                              ? 'bg-gradient-success'                             
                              : 'bg-gradient-warning'
                          "
                        >
                          {{ data.status == "lido" ? "Lido" : "Não Lido" }}</span>
                        </a>
                      </td>
                      <td>
                        <div class="px-4 py-1">
                          <div class="justify-content-center">
                            <h6 class="mb-0 text-sm">{{ data.notificacao.titulo }}</h6>
                          </div>
                        </div>
                      </td>

                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">{{
                          formatarData(data.created_at)
                        }}</span>
                      </td>

                      <td class="align-middle">
                        <a
                          href="javascript:;"
                          class="text-secondary font-weight-bold text-xs"
                          data-toggle="tooltip"
                          data-original-title="Abrir Notificação"
                          @click.prevent="abrir(data)"
                          >Abrir
                        </a>
                      </td>
                    
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <nav aria-label="navigation">
                <ul class="pagination pagination-primary">
                  <li class="page-item disabled">
                    <a class="page-link" href="">«</a>
                  </li>
                  <li class="page-item active">
                    <a
                      class="page-link"
                      href="http://localhost:8000/admin/usuarios?page=1"
                      >1</a
                    >
                  </li>
                  <li class="page-item disabled">
                    <a class="page-link" href="">»</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div
        class="modal fade"
        id="modalNotify"
        tabindex="-1"
        aria-labelledby="modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <form @submit.prevent="checkMode">
              <div class="modal-header">
                <h5 class="modal-title" id="modalLabel">Notificação</h5>
                <span
                  style="cursor: pointer"
                  @click="closeModal"
                  aria-label="Close"
                  aria-hidden="true"
                  >×</span
                >
              </div>

              <div class="modal-body">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label"
                      >Título</label
                    >
                    <h2>{{ form.notificacao.titulo }}</h2>
                  </div>
                  <div
                    class="invalid-feedback mb-3"
                    :class="{ 'd-block': form.errors.titulo }"
                  >
                    {{ form.errors.titulo }}
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label"
                      >Conteúdo</label
                    >
                    <h4>{{ form.notificacao.conteudo }}</h4>
                  </div>
                  <div
                    class="invalid-feedback mb-3"
                    :class="{ 'd-block': form.errors.conteudo }"
                  >
                    {{ form.errors.conteudo }}
                  </div>
                </div>

            
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click="closeModal"
                >
                  Fechar
                </button>
               
              </div>
            </form>
          </div>
        </div>
      </div>

    </template>
  </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import Pagination from "@/Components/Pagination";
import moment from "moment";
import axios from "axios";

export default {
  props: ["user", "notificacoes", "prefeituras", "usuarios"],
  components: {
    AdminLayout,
    Pagination,
    moment,
  },

  data() {
    return {
      modal: Object,
      modal2: Object,
      users: [],
      prefeitura: [],
      lojistas: [],
      set_tipo: "",
      set_prefeitura: "",

      roleOptions: this.roles,
      filter: "",
      editMode: false,

      form: this.$inertia.form({
        tipo: "",
        status: "ativo",
        notificacao: [],
      }),
    };
  },

  computed: {
    formTitle() {
      return this.editMode === false
        ? "Adicionar Notificação"
        : "Editar Notificação";
    },
    buttonTxt() {
      return this.editMode === false ? "Salvar" : "Editar";
    },
    checkMode() {
      return this.editMode === false ? this.create : this.update;
    },
  },

  watch: {


  },

  methods: {
    formatarData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm:ss");
    },

    list_lojistras(id) {
      axios.get("/api/notificacao/" + id).then((response) => {
        this.lojistas = response.data;
      });
    },

    checkPrefeitura(id) {
      for (var p in this.prefeitura) {
        if (id == this.prefeitura[p].id) {
          return this.prefeitura[p].descricao;
        }
      }
    },

    openModal() {
      this.editMode = false;
      this.form.clearErrors();
      this.modal.show();
      this.form.reset();
      this.set_tipo = "";
      this.set_prefeitura = "";
      this.set_lojista = "";
    },

    closeModal() {
      this.modal.hide();
      this.form.clearErrors();
      this.editMode = false;
    },

 
    abrir(user) {
      this.openModal();
      this.editMode = true;

      this.form = Object.assign(this.form, user);

      this.form.patch(
        this.route("admin.notificacao.updatelido", this.form.id),
        {
          preserveScroll: true,
          onSuccess: () => {
            // this.closeModal();
            // this.form.reset();
          },
        }
      );

      // console.log(this.form);
    },

    exibirNotificao(user) {
      this.editMode = true;

      this.form = Object.assign(this.form, user);

      this.form.role = user.roles[0];
    },


  },

  async mounted() {

    this.modal = new bootstrap.Modal(
      document.getElementById("modalNotify"),
      {}
    );


  },
};
</script>

